const dashboard = {
  dashboard: {
    title: 'ダッシュボード',
    switchToClassic: 'クラシックビューに切り替える',
    comingSoon: '近日公開',
    companyScoreCard: '会社業績スコアカード',
    enphaseSince: 'Enphaseの設置開始年',
    sitesCommissioned: '受託サイト',
    microinverters: 'マイクロインバータ設置',
    batteriesInstalled: 'バッテリーの取り付け',
    nps: 'ネット・プロモーター・スコア',
    ensembleCertified: '蓄電池認定設置会社',
    solarInstallCertified: 'ソーラー設置認定',
    einLearn: 'EINについてもっと知る',
    yes: 'はい',
    no: 'いいえ',
    lastMonth: {
      one: '過去1ヶ月',
      other: '過去 %{count} ヶ月'
    },
    congratulations: 'おめでとうございます!',
    acceptInvitation: '招待を受ける',
    einInvitation: 'Enphase Installer Networkへの参加招待状が届きました。',
    leadsInvitation: 'Enphase Leads Programへの参加招待状が届きました。',
    announcements: 'お知らせ',
    systems: 'システム',
    all: 'すべて',
    alerts: 'アラート',
    activations: 'アクティベーション',
    leads: 'リード',
    search: '検索',
    noResult: '結果が見つかりません',
    viewActivations: 'すべてのアクティベーションを表示',
    viewLeads: 'すべてのリードを表示',
    viewSystems: '全てのシステムを表示',
    addNewSystems: '新しいシステムを追加',
    total: '合計',
    activatedSites: 'アクティブ化したサイト',
    nameId: '名前/ID',
    status: 'ステータス',
    city: '市区町村',
    state: '都道府県',
    //TODO - new translation added
    leadSource: 'リード・ソース',
    createNewLead: '新規リードの作成',
    //TODO ends
    notAvailable: '利用不可',
    quickAccess: 'クイックアクセス',
    contactUs: 'お問い合わせ',
    ensemble: 'Ensemble',
    serviceShortcuts: 'サービスショートカット',
    newsletter: '設置業者のニュースレター',
    service: 'サービスマネージャー',
    enphaseleads: 'Enphase Leads Program',
    enphaseCommunity: 'Enphaseコミュニティ',
    enphaseStore: 'Enphase Store',
    systemConfigurator: 'システムビルダー',
    criticalUpdates: '重要なアップデート',
    documentation: 'ドキュメンテーション',
    brandLibrary: 'ブランドライブラリー',
    training: 'トレーニング',
    newsBoard: 'ニュース・ボード',
    noContentAvailable: '利用可能なコンテンツはありません',
    viewEinDashboard: 'EINダッシュボードを表示',
    enterComments: 'コメントを入力',
    maxAllowedComment: '最大 %{maxCount} 文字まで入力できます',
    switchingBackNote:
      'Enlighten Managerのクラシック・バージョンに戻りますか？新しいバージョンの改善に役立てるため、以前のバージョンに戻した理由を教えてください',
    switchBackTitle: '期間限定でクラシックビューに切り替える',
    new: '新規',
    view: '表示',
    gridProfileToken: 'グリッドプロファイル変更トークン',
    ProfileTokenText: 'プロファイル変更トークン',
    validText: 'このトークンはGateway %{serialNumber} で 1 日有効です。',
    envoySerialNumber: 'Gatewayのシリアル番号',
    authorizationNumber: '認証番号',
    getToken: 'トークンの取得',
    viewAll: 'すべてを見る',
    viewFullList: '全リストを見る',
    serviceRequests: 'サービスリクエスト',
    inProgressRequests: '進行中',
    // TODO - new translations added
    totalCases: 'ケースの総数',
    resolvedRequests: '解決済み',
    // TODO ends
    viewDetails: '詳細を見る',
    newFeature: '新機能',
    refreshStatus: 'ステータスを更新',
    prontoSignupMessage: '365 Pronto - クリーンテック求人マーケットプレイスでプロファイルが完成するまであと数クリックです。今すぐお申し込みください。',
    prontoButton: '365 Prontoに進む',
    defaultStatusText: 'ご不明な点がございましたら、「365 Prontoに進む」を選択し、365 Prontoサポートまでお問い合わせください。'
  }
};

export default dashboard;
